/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../../client.ts';
import type { RequestConfig, ResponseErrorConfig } from '../../../client.ts';
import type {
  TelegramNewsletterControllerCreateNewsletterMutationRequest,
  TelegramNewsletterControllerCreateNewsletterMutationResponse,
} from '../../types/TelegramNewsletterControllerCreateNewsletter.ts';
import type { UseMutationOptions, QueryClient } from '@tanstack/react-query';
import { telegramNewsletterCreateNewsletter } from '../../methods/telegramNewsletterCreateNewsletter.ts';
import { useMutation } from '@tanstack/react-query';

export const telegramNewsletterCreateNewsletterMutationKey = () => [{ url: '/api/telegram/newsletter' }] as const;

export type TelegramNewsletterCreateNewsletterMutationKey = ReturnType<
  typeof telegramNewsletterCreateNewsletterMutationKey
>;

/**
 * {@link /api/telegram/newsletter}
 */
export function useTelegramNewsletterCreateNewsletter<TContext>(
  options: {
    mutation?: UseMutationOptions<
      TelegramNewsletterControllerCreateNewsletterMutationResponse,
      ResponseErrorConfig<Error>,
      { data: TelegramNewsletterControllerCreateNewsletterMutationRequest },
      TContext
    > & { client?: QueryClient };
    client?: Partial<RequestConfig<TelegramNewsletterControllerCreateNewsletterMutationRequest>> & {
      client?: typeof fetch;
    };
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey = mutationOptions.mutationKey ?? telegramNewsletterCreateNewsletterMutationKey();

  return useMutation<
    TelegramNewsletterControllerCreateNewsletterMutationResponse,
    ResponseErrorConfig<Error>,
    { data: TelegramNewsletterControllerCreateNewsletterMutationRequest },
    TContext
  >(
    {
      mutationFn: async ({ data }) => {
        return telegramNewsletterCreateNewsletter(data, config);
      },
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  );
}
